import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'
import getISOFormattedTimestamp from '../utilities/getISOFormattedTimestamp'
import getCurrentUid from '../utilities/getCurrentUid'

const addReport = async (report) => {
	try {
		const uid = getCurrentUid()
		const isoDate = getISOFormattedTimestamp()

		//	Clean the data
		const reportDetails = {
			...report,
			type: report.type === 'report' ? 'report' : 'feedback',
			time: isoDate,
			timeStamp: (new Date()).getTime(),
			uid,
			requiresNotification: true
		}

		await firestore.collection('userReports').doc(uid)
			.collection(reportDetails.type === 'report' ? 'report' : 'feedback').doc(`DATE-${isoDate}`)
			.set(reportDetails)

		await firestore.collection('userReports').doc(uid).set({ requiresNotification: true })

		return { reportDetails }
	} catch (exception) {
		console.error('STACKED IT', exception)
		throw errorOfType(errorTypes.UNKNOWNERROR, exception.stack)
	}
}
export default addReport



// WEBPACK FOOTER //
// ./src/dataservices/addReport.js